import React, { LegacyRef, forwardRef } from 'react';

import { RoundButton } from '../RoundButton';
import { View } from 'react-native';

const flatImage = require('assets/flat_view.svg');
const satelliteImage = require('assets/satellite.svg');

export const LayerToggle = forwardRef(
  (props: { onPress: () => void; state }, ref: LegacyRef<View>) => {
    const image = props.state ? flatImage : satelliteImage;
    return (
      <View ref={ref}>
        <RoundButton
          onPress={props.onPress}
          image={image}
          color={'#fff'}
          size={40}
        />
      </View>
    );
  },
);
